import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { ICellRendererParams } from 'ag-grid-community';

import { ITrackInventory } from '@ruby/modules/track-move/models/track-move.interface';
import { ITrack } from '@ruby/shared/models/inventory-management/inventory-header.interface';
import { InventoryManagementUtils } from '@ruby/shared/services/utils/inventory-management/inventory-management.utils';

@Component({
  selector: 'ng-track-select-action',
  templateUrl: './track-select-action.component.html',
  styleUrls: ['./track-select-action.component.scss']
})
export class TrackSelectActionComponent implements OnChanges {
  @Input() inventoryTracks!: Array<ITrack>;
  @Input() params!: ICellRendererParams;
  @Input() toTrack!: ITrack;
  @Input() selectedFromTrack?: ITrack;

  constructor(private inventoryUtilsSvc: InventoryManagementUtils) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.inventoryTracks && changes.inventoryTracks.currentValue.length > 0 && this.params.data) {
      this.filterTracks();
    }
    if (changes.params && changes.params.currentValue.data && this.inventoryTracks.length > 0) {
      this.filterTracks();
    }
  }

  /**
   * Track Select
   *
   * @summary Updated the current row with new selected track
   * @param $param: MatSelectChange
   * @returns void
   */
  trackSelect($param: MatSelectChange): void {
    this.params.node.setData({ ...this.params.node.data, toTrack: $param.value });
    const availableRows: Array<ITrackInventory> = this.inventoryUtilsSvc.setPositionCount(this.params.api);
    this.params.api.applyTransaction({ update: availableRows });
  }

  private filterTracks(): void {
    this.inventoryTracks = this.inventoryTracks.filter((track: ITrack) => !track.mainTrack && this.params.data.id !== track.id);
  }
}
